import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export const FAQ: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    question: 'Wat kost een zakelijke website laten maken voor financieel adviseurs?',
    answer: "De kosten voor een zakelijke website laten maken financieel adviseur zijn afhankelijk van je wensen en de complexiteit van het project. Voor financieel adviseurs, administratiekantoren en accountants bieden we verschillende pakketten aan, van instapoplossingen vanaf €2.500 tot volledig maatwerk webdesign. Factoren die de prijs beïnvloeden zijn het aantal pagina's, maatwerk, functionaliteiten, SEO-optimalisatie, en contentcreatie. De kosten voor een professionele website voor een accountantskantoor variëren per project. Neem contact op voor een vrijblijvende offerte voor een website op maat voor een administratiekantoor."
  }, {
    question: 'Hoe lang duurt het om een website te bouwen?',
    answer: 'De doorlooptijd is afhankelijk van de grootte en complexiteit van het project. Een eenvoudige zakelijke website kan binnen 2-3 weken live zijn, terwijl een complexere website met maatwerk functionaliteiten 6-8 weken kan duren. We plannen dit samen in tijdens het eerste gesprek en houden je gedurende het hele traject op de hoogte.'
  }, {
    question: 'Krijg ik ook ondersteuning na de oplevering?',
    answer: 'Ja, we bieden verschillende onderhoudspakketten aan speciaal voor zakelijke websites. Van basis hosting en updates tot uitgebreide support met maandelijkse optimalisaties, SEO-monitoring en technische begeleiding. Je kiest zelf wat bij jouw situatie en budget past.'
  }, {
    question: 'Kan ik zelf aanpassingen doen aan mijn website?',
    answer: 'Absoluut! We bouwen je zakelijke website in WordPress, een gebruiksvriendelijk systeem waar je zelf eenvoudig content kunt aanpassen zonder technische kennis. Tijdens de oplevering geven we een uitgebreide uitleg en training, en je kunt altijd bij ons terecht voor vragen of ondersteuning.'
  }];
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <div className="w-full bg-white py-20 md:py-24" data-id="element-254">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-[900px]" data-id="element-255">
        <div className="text-center mb-12" data-id="element-256">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-bold text-[#111827] mb-4 text-3xl md:text-4xl" data-id="element-257">
            Veelgestelde vragen
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-[#6B7280] text-lg" data-id="element-258">
            Heb je nog vragen over een zakelijke website laten maken? Neem
            gerust contact op!
          </motion.p>
        </div>
        <div className="space-y-4" data-id="element-259">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-[#F7F8FA] rounded-xl overflow-hidden" data-id="element-260">
              <button onClick={() => toggleFAQ(index)} className="w-full flex items-center justify-between p-6 text-left hover:bg-gray-100 transition-colors" data-id="element-261">
                <span className="font-semibold text-[#111827] pr-8" data-id="element-262">
                  {faq.question}
                </span>
                <motion.div animate={{
              rotate: openIndex === index ? 180 : 0
            }} transition={{
              type: 'spring',
              stiffness: 200,
              damping: 20
            }} data-id="element-263">
                  <ChevronDownIcon className="h-5 w-5 text-[#007AFF] flex-shrink-0" data-id="element-264" />
                </motion.div>
              </button>
              <AnimatePresence data-id="element-265">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} className="overflow-hidden" data-id="element-266">
                    <div className="px-6 pb-6 text-[#6B7280] leading-relaxed border-t border-gray-200/50 pt-4" data-id="element-267">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </div>;
};